(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yeppo-cyber-ticker"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('yeppo-cyber-ticker')){
customElements.define('yeppo-cyber-ticker',class extends HTMLElement{
connectedCallback(){
this.end=Date.parse(this.dataset.end);
this.wrapper=this.closest('.shopify-section');
this.wrapper?.classList.add('yeppo-cyber-sticky');
this.updatePosition=()=>{
this.frame=null;
const header=document.querySelector('[data-site-header-sticky]');
let top=0;
if(header){
const rect=header.getBoundingClientRect();
if(rect.top<=1&&rect.bottom>0)top=rect.bottom;
}
this.wrapper?.style.setProperty('--yct-sticky-top',Math.max(0,top)+'px');
};
this.onScroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.updatePosition);};
window.addEventListener('scroll',this.onScroll,{passive:true});
window.addEventListener('resize',this.onScroll);
this.headerObserver=new ResizeObserver(this.onScroll);
const header=document.querySelector('[data-site-header-sticky]');
if(header)this.headerObserver.observe(header);
this.updatePosition();
this.refresh=()=>{
const left=this.end-Date.now();
if(!Number.isFinite(this.end)||left<=0){this.hidden=true;clearInterval(this.interval);return;}
const minutes=Math.ceil(left/60000);
this.querySelector('[data-days]').textContent=String(Math.floor(minutes/1440)).padStart(2,'0');
this.querySelector('[data-hours]').textContent=String(Math.floor(minutes/60)%24).padStart(2,'0');
this.querySelector('[data-minutes]').textContent=String(minutes%60).padStart(2,'0');
this.hidden=false;
};
this.refresh();
if(Number.isFinite(this.end)&&this.end>Date.now())this.interval=setInterval(this.refresh,1000);
}
disconnectedCallback(){clearInterval(this.interval);cancelAnimationFrame(this.frame);window.removeEventListener('scroll',this.onScroll);window.removeEventListener('resize',this.onScroll);this.headerObserver?.disconnect();this.wrapper?.classList.remove('yeppo-cyber-sticky');}
});
}

  } catch(e) { console.error(e); }
})();
})();
